import type { CardBackLogoType } from '../types';

// Human-readable names for each logo type
export const LOGO_NAMES: Record<CardBackLogoType, string> = {
  'd20': 'D20 Die',
  'crossed-swords': 'Crossed Swords',
  'dragon': 'Dragon',
  'spellbook': 'Spellbook',
  'wizard-tower': 'Wizard Tower',
  'crystal-ball': 'Crystal Ball',
  'potion-bottle': 'Potion Bottle',
  'shield-crest': 'Shield & Crest',
  'arcane-runes': 'Arcane Runes',
  'skull-bones': 'Skull & Bones',
};
